// Time that the banner holds in for reading
export const READ_BANNER_TIME = 1450;
// Time that the banner holds in for complex reading
export const COMPLEX_READ_BANNER_TIME = 2000;
// Time for the banner to move in or move out of the screen
export const BANNER_TRANSITION_TIME = 350;
// Delay between the 2 parts of the banner
export const BANNER_FRONT_TRANSITION_DELAY = 60;
// Time for the denied banner to come down vertically.
export const DENIED_BANNER_TRANSITION_TIME = 300;
// Time that banner holds still when contacting
export const READ_CONTACT_BANNER_TIME = 175;
// Time for initial in/out of Contact banner
export const BANNER_SHORT_TRANSITION_TIME = 300;
// Time difference between front/back banner for initial in/out of Contact banner
export const BANNER_SHORT_FRONT_TRANSITION_DELAY = 45;
export function getAnnouncementBannerTime() {
    return BANNER_TRANSITION_TIME * 2 + READ_BANNER_TIME;
}
export function getComplexAnnouncementBannerTime() {
    return BANNER_TRANSITION_TIME * 2 + COMPLEX_READ_BANNER_TIME;
}
export function getDeniedBannerFinishTime() {
    return DENIED_BANNER_TRANSITION_TIME + COMPLEX_READ_BANNER_TIME + BANNER_TRANSITION_TIME;
}
//# sourceMappingURL=BannerTimelineConstants.js.map